<header class="account-market-cards-header">
  <h3 class="account-market-cards-title">{{ 'supermarket_cards' | translate }}</h3>
</header>
<main class="account-market-cards-body">
  <ng-container *ngIf="hasCards; else noCards">
    <p class="account-market-cards-subtitle">{{ 'supermarket_cards_text' | translate }}</p>

    <div class="account-market-cards-container">
      <div *ngFor="let marketCard of marketCards" class="account-market-card-wrapper">
        <h4 class="account-market-card-title">{{ marketCard.shopName }} Supermarkets</h4>
        <div class="account-market-card-container">
          <market-card [marketCard]="marketCard"></market-card>
          <button
            box-button
            size="small"
            theme="secondary"
            borders="none"
            class="account-market-card-button"
            (click)="onMarketCardDelete(marketCard)"
          >
            {{ 'remove_' | translate }}
          </button>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #noCards>
    <div class="account-market-cards-empty-state">
      <p class="account-market-cards-empty-state-text">{{ 'no_saved_cards_found' | translate }}</p>
      <figure class="account-market-cards-empty-state-image image contain-image">
        <img src="/assets/images/payments/cards.svg" [attr.alt]="'no_saved_cards_found' | translate" />
      </figure>
      <p class="account-market-cards-empty-state-text">{{ 'add_new_sm_card_info_text' | translate }}</p>
    </div>
  </ng-template>
</main>
